<template>
  <div>
    <!-- Label -->
    <label :class="labelComputedClasses" :for="id">
      <span>{{ label }}</span>
      <ips-tooltip v-if="tooltip" :tooltip="tooltip">
        <template slot="tip">
          <ips-icon icon="ico-help"></ips-icon>
        </template>
      </ips-tooltip>
    </label>

    <div :class="formComputedClasses">
      <textarea
        :id="id"
        class="form-control"
        :class="inputComputedClasses"
        :value="value"
        :disabled="disabled"
        :required="required"
        :placeholder="placeholder"
        :tabindex="tabindex"
        :maxlength="maxlength"
        @input="handleInput"
      ></textarea>
      <small v-if="error" class="ips-validation form-text text-danger">
        <ips-icon icon="ico-danger" size="sm"></ips-icon>
        <!-- @slot Use this slot to populate a validation/error message -->
        <slot name="errorText"></slot>
      </small>
    </div>
  </div>
</template>

<script>
import IpsIcon from '@ipscape/ips-icon';
import IpsTooltip from '@ipscape/ips-tooltip';
import { formFieldsMixin } from '../../../mixins/index.js';

export default {
  name: 'IpsTextarea',
  components: {
    IpsIcon,
    IpsTooltip,
  },
  mixins: [formFieldsMixin],
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
textarea:focus::placeholder {
  color: transparent;
}
</style>
